import { Box, Button } from '@mui/material';
import { styled } from 'styled-components';
import backgroundImage from '../../../../images/Orbito-BG.png';
import Paper from '../../../common/layout/Paper';

export const LoadingContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	padding: 3rem;
`;

export const ProfilePhotoContainer = styled(Box)`
	display: flex;
	align-items: center;
	gap: 1rem;
	margin-bottom: 2rem;
`;

export const ProfilePhotoUpload = styled(Box)`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: 2px dashed #555;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background-color: #2a2a2a;
	position: relative;
	overflow: hidden;

	&:hover {
		border-color: #1976d2;
	}
`;

export const ProfileImage = styled('img')`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
`;

export const PreferredAirlinerSection = styled(Box)`
	padding: 1rem;
	border: 1px solid #444;
	border-radius: 8px;
`;

export const ContentContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const ScrollableContent = styled(Box)`
	flex: 1;
	overflow-y: auto;
	padding: 0 24px;
	${({ theme }) => theme.breakpoints.down('sm')} {
		padding: 0 14px;
	}
`;

export const StickyHeader = styled(Box)`
	position: sticky;
	top: 0;
	z-index: 10;
	background-color: inherit;
	padding: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
	${({ theme }) => theme.breakpoints.down('sm')} {
		padding: 14px;
	}
`;

export const FixedButtonsContainer = styled(Box)``;

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100vw;
	position: relative;
	${({ theme }) => theme.breakpoints.down('sm')} {
		align-items: flex-start;
		margin-top: 50px;
		padding-left: 10px;
		padding-right: 10px;
		width: calc(100vw - 20px);
	}
	&::before {
		content: '';
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		background-image: url(${backgroundImage});
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		background-attachment: fixed;
	}
`;

export const StyledPaper = styled(Paper)`
	flex: 1;
	max-width: 900px;
	width: 100%;
	padding: 16px;
	border-radius: 16px;
	${({ theme }) => theme.breakpoints.down('sm')} {
		width: calc(100vw - 70px);
	}
`;

export const LogoContainer = styled(Box)`
	position: absolute;
	top: 20px;
	left: 20px;
`;

export const LogoImage = styled('img')`
	height: 30px;
	cursor: pointer;
`;

export const MainContentContainer = styled(Box)`
	width: 100%;
	border-radius: 2px;
	position: relative;
	flex: 1;
	overflow: hidden;
	height: calc(100vh - 120px);
	display: flex;
	flex-direction: column;
	background-color: #1c1c1c;

	${({ theme }) => theme.breakpoints.down('sm')} {
		// height: calc(100vh - 65px);
		height: 100%;
	}
`;

export const PaperHeader = styled.div`
	color: ${(props) => props.theme.palette.text.primary};
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	font-weight: bold;
	font-size: 24px;
`;

export const HeaderFlexContainer = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const LogoutButton = styled(Button)`
	color: ${({ theme }) => theme.palette.text.secondary};
	border-color: ${({ theme }) => theme.palette.text.secondary};
	font-size: 0.875rem;
	padding: 4px 12px;

	&:hover {
		border-color: ${({ theme }) => theme.palette.text.primary};
		color: ${({ theme }) => theme.palette.text.primary};
	}
`;

export const StepperContainer = styled(Box)`
	flex: 1;
	margin-top: 2px;
`;

export const NavigationButtonsContainer = styled(Box)`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 2px;
	width: 100%;
	margin-bottom: 2px;
	margin-top: 2px;
`;

export const InnerNavigationButtons = styled(Box)`
	display: flex;
	gap: 2px;
	${({ theme }) => theme.breakpoints.down('sm')} {
		width: 100%;
		padding-bottom: 10px;
	}
`;

export const PrimaryActionButton = styled(Button)`
	width: auto;
	margin-bottom: 16px !important;

	${({ theme }) => theme.breakpoints.down('sm')} {
		width: 100%;
		padding-bottom: 10px;
	}
`;

export const ContentArea = styled(Box)`
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: scroll;
`;
